/**
 * Dates in Finnish time on the server too: the server runs in UTC, so a CMS date at midnight Finnish time
 * (e.g. 2026-09-29T21:00:00Z) showed the previous day in the server HTML and the right one in the browser,
 * a hydration mismatch on the front page (26.10.2026).
 */
const TIME_ZONE = 'Europe/Helsinki'

const formatDatetime = (unix: string, dayAsString: boolean): string => {
  const datetime = new Date(unix).toLocaleString('fi-FI', {
    year: 'numeric', month: 'numeric', day: 'numeric', hour: '2-digit', minute: '2-digit', timeZone: TIME_ZONE
  })
  let returnable = datetime

  if (dayAsString) {
    const yesterdayUnix = new Date().setDate(new Date().getDate() - 1)
    const givenDate = new Date(unix).toLocaleString('fi-FI', { year: 'numeric', month: 'numeric', day: 'numeric', timeZone: TIME_ZONE })
    const dateNow = new Date().toLocaleString('fi-FI', { year: 'numeric', month: 'numeric', day: 'numeric', timeZone: TIME_ZONE })
    const dateYesterday = new Date(yesterdayUnix).toLocaleString('fi-FI', { year: 'numeric', month: 'numeric', day: 'numeric', timeZone: TIME_ZONE })

    if (givenDate === dateNow) {
      returnable = datetime.replace(givenDate, 'Tänään')
    }
    else if (givenDate === dateYesterday) {
      returnable = datetime.replace(givenDate, 'Eilen')
    }
  }

  return returnable
}

const formatDate = (unix: string, monthAsString?: boolean): string => {
  const monthFormat = monthAsString ? 'long' : 'numeric'
  return new Date(unix).toLocaleString('fi-FI', {
    year: 'numeric', month: monthFormat, day: 'numeric', timeZone: TIME_ZONE
  })
}

export { formatDate, formatDatetime }
